import React, { Component } from 'react';
import {  BrowserRouter as Router, Route } from 'react-router-dom'
import './App.css';

import Menu from "./components/Menu";
import Island from "./components/Island";
import Characters from "./components/Characters";
import Setting from "./components/Setting";

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faQuestion, faDotCircle, faBan, faMap, faUsers, faExclamation, faUserPlus, faMinusCircle, faPlusCircle, faAnchor, faQuestionCircle, faExclamationTriangle, faCertificate, faFire, faTrash, faBoxOpen, faPlus, faGlobeAsia, faComments, faCalendar, faShoppingCart, faCircle } from '@fortawesome/free-solid-svg-icons'

library.add(faQuestion, faDotCircle, faBan, faMap, faUsers, faExclamation, faUserPlus, faMinusCircle, faPlusCircle, faAnchor, faQuestionCircle, faExclamationTriangle, faCertificate, faFire, faTrash, faBoxOpen, faPlus, faGlobeAsia, faComments, faCalendar, faShoppingCart, faCircle)

class App extends Component {
	
	render() {
		return (
		<Router>
			<div className="App">
			<div className="Header">
					<div className="Header-Inner">
						<div className="AppTitle">Engorath Redux</div>
						<Menu />
					</div>
				</div>
				<Route path="/edit/:key" component={Island} />
				<Route exact path="/" component={Island} />
				<Route exact path="/personnages" component={Characters} />
				<Route exact path="/univers" component={Setting} />
				
				<Route path="/engorath2/edit/:key" component={Island} />
				<Route exact path="/engorath2" component={Island} />
				<Route exact path="/engorath2/personnages" component={Characters} />
				<Route exact path="/engorath2/univers" component={Setting} />
			</div>
		</Router>
		);
	}
}

export default App;
